import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Lock, Mail } from "lucide-react";
import { useAuth, formatApiError } from "../context/AuthContext";

// Halaman masuk khusus admin (akun harus ber-role admin)
export default function AdminLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const u = await login(form.email, form.password);
      if (u?.role !== "admin") { await logout(); setErr("Akun ini bukan admin. Gunakan akun admin KencanKita."); return; }
      navigate("/admin");
    } catch (ex) { setErr(formatApiError(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#1f1b18] px-4 text-[#2b2521]" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white p-7 shadow-2xl">
        <div className="mb-5 flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-2xl kk-coral-gradient text-white"><Shield className="h-5 w-5" /></span>
          <div><div className="text-[11px] font-bold uppercase tracking-wider text-[#ff5a5f]">Khusus admin</div><h1 className="text-xl font-extrabold">Masuk Admin</h1></div>
        </div>
        <label className="text-[12px] font-bold text-[#6e594c]">Email admin</label>
        <div className="mb-3 mt-1 flex items-center gap-2 rounded-2xl border border-[#eee5da] bg-[#fcfaf7] px-3">
          <Mail className="h-4 w-4 text-[#a69995]" />
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email-input" className="w-full bg-transparent py-2.5 text-[14px] outline-none" placeholder="adminkencankita@gmail.com" />
        </div>
        <label className="text-[12px] font-bold text-[#6e594c]">Kata sandi</label>
        <div className="mb-4 mt-1 flex items-center gap-2 rounded-2xl border border-[#eee5da] bg-[#fcfaf7] px-3">
          <Lock className="h-4 w-4 text-[#a69995]" />
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password-input" className="w-full bg-transparent py-2.5 text-[14px] outline-none" />
        </div>
        {err && <div className="mb-3 rounded-2xl bg-[#ffe3e3] px-3 py-2 text-[12px] font-semibold text-[#c0343a]" data-testid="admin-login-error">{err}</div>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full rounded-2xl kk-coral-gradient py-3 text-[14px] font-bold text-white disabled:opacity-60">{busy ? "Memeriksa…" : "Masuk ke dashboard"}</button>
        <a href="/login" className="mt-4 block text-center text-[12px] font-semibold text-[#a69995] hover:text-[#ff5a5f]">Masuk sebagai pasangan →</a>
      </form>
    </div>
  );
}
